module.exports = __webpack_public_path__ + "images/173_320.jpg";